import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
const KEY = 'dcc-admin-session';
const PASSCODE = 'dailycc';
type Ctx = {
  signedIn: boolean;
  signIn: (code: string) => boolean;
  signOut: () => void;
};
const AdminAuthContext = createContext<Ctx | null>(null);
export function AdminAuthProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [signedIn, setSignedIn] = useState(false);
  useEffect(() => {
    try {
      setSignedIn(window.sessionStorage.getItem(KEY) === 'yes');
    } catch {
      /* ignore */
    }
  }, []);
  const signIn = useCallback((code: string) => {
    if (code.trim().toLowerCase() !== PASSCODE) return false;
    setSignedIn(true);
    try {
      window.sessionStorage.setItem(KEY, 'yes');
    } catch {
      /* ignore */
    }
    return true;
  }, []);
  const signOut = useCallback(() => {
    setSignedIn(false);
    try {
      window.sessionStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
  }, []);
  return <AdminAuthContext.Provider value={{
    signedIn,
    signIn,
    signOut
  }} data-id="element-756" data-mp="oo8bk62pgwd">{children}</AdminAuthContext.Provider>;
}
export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error('useAdminAuth must be used inside AdminAuthProvider');
  return ctx;
}